import { Flow, Routes } from "@ctypes";
import { useEditGoal, useErrorBanner, useGoalFlow } from "@hooks";
import { useNavigate } from "@entry/navigation";
import { GoalNameFormValues } from "./types";

export const useGoalNameScreenFlow = () => {
  const navigate = useNavigate();

  const {
    goalProps: { flow, goalId, goalType, beneficiaryId },
    setGoalProps,
    clearGoalProps,
  } = useGoalFlow();

  const { showErrorBanner } = useErrorBanner();

  const [editGoal, { loading }] = useEditGoal();

  const handleDefaultFlow = () => {
    navigate(Routes.TaxFlexibility);
  };

  const handleEditGoalFlow = async (goalName: string) => {
    if (goalId && beneficiaryId) {
      try {
        await editGoal({
          variables: {
            goalId,
            goalType,
            goalName,
          },
        });

        navigate(-1);
        navigate(-1);

        clearGoalProps();
      } catch {
        showErrorBanner();
      }
    } else {
      showErrorBanner();
    }
  };

  const handleSubmit = ({ goalName }: GoalNameFormValues) => {
    setGoalProps({
      goalName,
    });

    if (flow === Flow.EditGoal) {
      handleEditGoalFlow(goalName);
    } else {
      handleDefaultFlow();
    }
  };

  return { handleSubmit, loading };
};
